import { render, staticRenderFns } from "./NestedTasks.vue?vue&type=template&id=4e334aad&scoped=true"
import script from "./NestedTasks.vue?vue&type=script&lang=js"
export * from "./NestedTasks.vue?vue&type=script&lang=js"
import style0 from "./NestedTasks.vue?vue&type=style&index=0&id=4e334aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e334aad",
  null
  
)

export default component.exports